import { render, staticRenderFns } from "./ProfileFormFields.vue?vue&type=template&id=33ede81c&scoped=true&"
import script from "./ProfileFormFields.vue?vue&type=script&lang=js&"
export * from "./ProfileFormFields.vue?vue&type=script&lang=js&"
import style0 from "./ProfileFormFields.vue?vue&type=style&index=0&id=33ede81c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ede81c",
  null
  
)

export default component.exports